var Handlebars = require("/home/ploi/app.ecolenatationthonex.ch/releases/1749609694128/client/node_modules/@insolus/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span class=\"loading__icon\"></span>\n<span class=\"loading__text\">"
    + container.escapeExpression((helpers.i18n || (depth0 && depth0.i18n) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"loading",{"name":"i18n","hash":{},"data":data}))
    + "</span>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/views/themes/front/components/loading/loading.hbs
// module id = 924
// module chunks = 1